import Button from "@mui/material/Button";
import { useAuth0 } from "@auth0/auth0-react";

export default function LoginButton(props = {}) {
  const { loginWithRedirect } = useAuth0();

  return (
    <Button color="inherit" onClick={() => loginWithRedirect()} {...props}>
      Login
    </Button>
  );
}
